<template>
  <div class="center-layout">
    <CommonHeader />
    <main class="center-page">
      <div class="center-content">
        <router-view></router-view>
      </div>
    </main>

    <footer class="footer">
      <div class="center-content footer-container">
        <div class="footer-content">
          <div class="footer-left">
            <PlayCircle class="footer-icon" />
            <span class="footer-text">© 2026 智学云平台。保留所有权利。</span>
          </div>
          <div class="footer-links">
            <a href="#">帮助中心</a>
            <a href="#">服务条款</a>
            <a href="#">隐私政策</a>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import CommonHeader from '@/components/header/CommonHeader.vue'

export default {
  name: 'Center',
  components: {
    CommonHeader
  }
}
</script>

<style scoped>
.center-layout {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: #f4f7fa;
}

.center-page {
  flex: 1;
  padding: 32px 24px 40px;
  background: #f4f7fa;
}

.center-content {
  width: min(100%, 1200px);
  margin: 0 auto;
}

.footer {
  background-color: #ffffff;
  border-top: 1px solid #e5e7eb;
  margin-top: 3rem;
}

.footer-container {
  padding-top: 2rem;
  padding-bottom: 2rem;
}

.footer-content {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
}

.footer-left {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.footer-icon {
  color: #9ca3af;
  width: 20px;
  height: 20px;
}

.footer-text {
  font-size: 14px;
  color: #6b7280;
}

.footer-links {
  display: flex;
  align-items: center;
  gap: 1.5rem;
}

.footer-links a {
  font-size: 14px;
  color: #6b7280;
  text-decoration: none;
  transition: color 0.2s;
}

.footer-links a:hover {
  color: #1a71ff;
}

@media (max-width: 768px) {
  .center-page {
    padding: 20px 16px 32px;
  }

  .footer-content {
    flex-direction: column;
  }
}

@media (max-width: 480px) {
  .footer {
    margin-top: 2rem;
  }

  .footer-content {
    gap: 0.75rem;
  }

  .footer-text {
    font-size: 12px;
  }

  .footer-links {
    flex-direction: column;
    align-items: center;
    gap: 0.75rem;
  }

  .footer-links a {
    font-size: 12px;
  }
}
</style>
